import { createContext, useContext } from "react";
import { AuthContext } from ".";
import { toast } from 'react-toastify';
import { conection } from '../utils/index'
import moment from "moment";


export const AuthContextApi = createContext();


const AuthProvider = ({ children }) => {

    const { states, setters } = useContext(AuthContext);
    const axiosAuth = conection.auth();
    const axiosNoAuth = conection.noAuth();
    const axiosAuthInvestidor = conection.authInvestidor();
    const axiosNoAuthInvestidor = conection.noAuthInvestidor();


    const login = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.get('/user/login')
            const response = await axiosNoAuth.post('/user/login', data)
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('permisssion', response.data.data.permissao)
            localStorage.setItem('cliente', response.data.data.client)
            localStorage.setItem('usuario', response.data.data.user)
            localStorage.setItem('proprietario', response.data.data.proprietario)
            setters.setSigned(true)
            setters.setIsLoading(false)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            // console.log(err)
            setters.setIsLoading(false)
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const checkLogin = async () => {
        try {
            await axiosAuth.get('/user/check')
            return true;
        } catch (err) {
            console.log(err)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const forgotPass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotPassword', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const forgotChangePass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotChangePass', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const logout = async () => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get('/user/logOut')
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }


    //#region Recuperação de Senha

    const getRecuperacaoDeSenhaDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/recuperacaoSenha')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRecuperacaoSenha(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenha = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenhaQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/${query}/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    //#endregion

    //#region Usuários

    const getUsuariosDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/usuarios')
            setters.setIsLoading(false)
            setters.setDataEstatisticaUsuarios(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuarios = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuariosQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const postUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/user/create', data)
            setters.setIsLoading(false)
            toast.success('Usuário cadastrado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const putRoleUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/role/${states.Usuarios.id}`, data)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário editado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const blockUnlockUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/blockUnlock/${id}`, { noData: "data" })
            setters.setIsLoading(false)
            setters.setUsuarios({})
            const msg = status ? 'Usuário desbloqueado com sucesso' : 'Usuário bloqueado com sucesso'
            toast.success(msg)
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const deleteUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/user/${id}`)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário deletado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    //#endregion

    //#region Logs

    const getLogsDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/logs')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/logs/metricas')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRequestsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/requests/metrics')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRequests(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogs = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/logs?${query}`)
            setters.setIsLoading(false)
            setters.setDataLogs(response.data.data)
            if (response.data.data.length === 0) toast.success('Logs carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                // Reset para página anterior se houver erro
                if (states.page > 0) {
                    setters.setPage(states.page - 1)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    //#endregion

    //#region dashBoard


    const getDashBoardataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/dashBoard`)
            setters.setIsLoading(false)
            return response.data
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return { status: false };
            } else {
                toast.error(err.response.data.msg)
                return { status: false };
            }
        }
    }

    //#endregion

    //#region profile



    const profileChangeEmail = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changeemail`, data)
            setters.setIsLoading(false)
            const saveEmail = localStorage.getItem('userEmail')
            if (saveEmail) {
                localStorage.setItem('userEmail', data.email)
            }
            toast.success('Email alterado com sucesso. Confirme a alteração no seu e-mail atual')
            return { status: true };
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return { status: false }
            } else {
                toast.error(err.response.data.msg)
            }
            return { status: false };
        }
    }


    const profileChangeSenha = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changePassword`, data)
            const saveSenha = localStorage.getItem('userPassword')
            if (saveSenha) {
                localStorage.setItem('userPassword', data.novaSenha)
            }
            setters.setIsLoading(false)
            toast.success('Senha alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err)
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirm = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/changeemail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileAutenticationEmail = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/authEmail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email autenticado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirmCheckLink = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get(`/user/checkLink/${token}`)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            toast.error(err.response.data.msg)

            return false;
        }
    }

    //#endregion

    //#region Investidores

    const getInvestidoresDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/investidores`)
            setters.setIsLoading(false)
            setters.setDataEstatisticaInvestidores(response.data.data)
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return { status: false };
        }
    }

    const getInvestidores = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/investidores?${query}`)
            console.log(response.data.data)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de investidores atingido')
                return
            }
            setters.setDataInvestidores(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return { status: false };
        }
    }

    const postInvestidores = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/investidores', data)
            setters.setIsLoading(false)
            toast.success('Investidor cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const patchInvestidores = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/investidores/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Investidor editado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const bloquearDesbloquearInvestidores = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/investidores/bloquear-desbloquear/${id}`)
            setters.setIsLoading(false)
            toast.success('Investidor bloqueado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    //#endregion


    //#region Investimentos

    const getInvestimentosDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/empreendimentos`)
            setters.setIsLoading(false)
            setters.setDataEstatisticaInvestimentos(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const getInvestimentos = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/empreendimentos?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de investimentos atingido')
                return
            }
            setters.setDataInvestimentos(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }


    const postInvestimentos = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/empreendimentos', data)
            setters.setIsLoading(false)
            toast.success('Investimento cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const patchInvestimentos = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/empreendimentos/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Investimento editado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;

        }
    }

    //#endregion

    //#region Obras

    const getObras = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/obras?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de obras atingido')
                return
            }
            setters.setDataObras(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const postObras = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/obras', data)
            setters.setIsLoading(false)
            toast.success('Obra cadastrada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const patchObras = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/obras/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Obra editada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const postObrasProcessarDados = async (id) => {
        try {
            const response = await axiosAuth.post('/obras/processar-dados', { id })
            toast.success(response.data.msg || 'Processamento iniciado com sucesso.')
            return true
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao processar dados da obra')
            return false
        }
    }

    //#endregion


    //#region InvestidoresInvestimentos 

    const getInvestidoresInvestimentos = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/empreendimento-investidores?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de investidores investimentos atingido')
                return
            }
            setters.setDataInvestidoresInvestimentos(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const postInvestimentosInvestidores = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/empreendimento-investidores', data)
            setters.setIsLoading(false)
            toast.success('Investidor investimento cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const patchInvestimentoStatusBloquearDesbloquear = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/empreendimento-investidores/status`, data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            console.log(err)
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    //#endregion

    //#region Obra Investidores

    const fetchObras = async (query) => {
        try {
            const response = await axiosAuth.get(`/obras?${query}`)
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar obras')
            return []
        }
    }

    const fetchInvestidores = async (query) => {
        try {
            const response = await axiosAuth.get(`/investidores?${query}`)
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar investidores')
            return []
        }
    }

    const getObraInvestidores = async (query) => {
        try {
            const response = await axiosAuth.get(`/obra-investidores?${query}`)
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar investidores da obra')
            return []
        }
    }

    const postObraInvestidor = async (data, { silent = false } = {}) => {
        if (!silent) setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/obra-investidores', data)
            if (!silent) {
                setters.setIsLoading(false)
                toast.success(response.data.msg || 'Investidor vinculado à obra com sucesso')
            }
            return { ok: true, msg: response.data.msg }
        } catch (err) {
            if (!silent) setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            const msg = err.response?.data?.msg || 'Erro ao vincular investidor à obra'
            if (!silent) toast.error(msg)
            return { ok: false, msg }
        }
    }

    const deleteObraInvestidor = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.delete(`/obra-investidores/${id}`)
            setters.setIsLoading(false)
            toast.success(response.data.msg || 'Vínculo removido com sucesso')
            return true
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao remover vínculo')
            return false
        }
    }

    //#endregion

    //#region Acesso do  investidor


    const loginInvestidor = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosNoAuthInvestidor.post('/verificacao-duas-etapas', data)
            setters.setIsLoading(false)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const loginStep2Investidor = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosNoAuthInvestidor.post('/verificacao-duas-etapas/codigo', data)
            setters.setIsLoading(false)
            setters.setSignedInvestidor(true)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const checkLoginInvestidor = async () => {
        try {
            await axiosAuthInvestidor.get('/validado')
            return true;
        } catch (err) {
            if (err.response.status === 403) {
                setters.setSignedInvestidor(false)
                return false;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const logoutInvestidor = async () => {
        setters.setIsLoading(true)
        try {
            await axiosAuthInvestidor.get('/logout')
        } catch (_) {
            // mesmo em erro, garante o logout local
        } finally {
            setters.setIsLoading(false)
            setters.setSignedInvestidor(false)
        }
    }

    const getEmpreendimentosInvestidor = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuthInvestidor.get('/empreendimentos')
            setters.setIsLoading(false)
            setters.setDataEmpreendimentos(response.data.data ?? [])
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                setters.setSignedInvestidor(false)
                return
            }
            toast.error(err.response?.data?.msg)
        }
    }

    const fetchEmpreendimentosInvestidorSilencioso = async (signal) => {
        try {
            const response = await axiosAuthInvestidor.get('/empreendimentos', { signal })
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') throw err
            return []
        }
    }

    const normalizeObraInvestidorRow = (row) => {
        if (row?.vinculo_id != null && row?.obra_id != null) return row
        return {
            ...row,
            vinculo_id: row.vinculo_id ?? row.id,
            id: row.obra_id ?? row.id,
        }
    }

    const fetchObrasInvestidorSilencioso = async (query, signal) => {
        try {
            const response = await axiosAuthInvestidor.get(`/obras?${query}`, { signal })
            if (!response.data?.status) return []
            return (response.data.data ?? []).map(normalizeObraInvestidorRow)
        } catch (err) {
            if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') throw err
            return []
        }
    }

    const getObrasInvestidor = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuthInvestidor.get(`/obras?${query}`)
            setters.setIsLoading(false)
            const rows = (response.data.data ?? []).map(normalizeObraInvestidorRow)
            if (rows.length === 0) {
                toast.success('Nenhuma obra encontrada')
                setters.setDataObras([])
                return
            }
            setters.setDataObras(rows)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                setters.setSignedInvestidor(false)
                return
            }
            toast.error(err.response?.data?.msg)
        }
    }

    //#endregion

    //#region Movimentação Financeira Obra

    const getMovimentacaoObraDataSistema = async (obra_id, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/dadosSistema/movimentacao?obra_id=${obra_id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticasMovimentacao(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const getMovimentacaoObra = async (query, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/movimentacao-financeira?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de movimentações atingido')
                setters.setDataMovimentacao([])
                return
            }
            setters.setDataMovimentacao(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    //#endregion

    //#region A Receber Obra

    const getAReceberObraDataSistema = async (obra_id, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/dadosSistema/a-receber?obra_id=${obra_id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticasAReceber(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const getAReceberObra = async (query, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/a-receber?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de a receber atingido')
                setters.setDataAReceber([])
                return
            }
            setters.setDataAReceber(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    //#endregion

    //#region Recebidos Obra

    const getRecebidosObraDataSistema = async (obra_id, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/dadosSistema/recebidos?obra_id=${obra_id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticasRecebidos(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const getRecebidosObra = async (query, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/recebidos?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de recebidos atingido')
                setters.setDataRecebidos([])
                return
            }
            setters.setDataRecebidos(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    //#endregion

    //#region Vendas Obra

    const getVendasObraDataSistema = async (obra_id, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/dadosSistema/vendas?obra_id=${obra_id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticasVendas(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const getVendasObra = async (query, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/vendas?${query}`)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de vendas atingido')
                setters.setDataVendas([])
                return
            }
            setters.setDataVendas(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    //#endregion

    //#region Estoque Obra

    const getEstoqueObraDataSistema = async (obra_id, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/dadosSistema/estoque?obra_id=${obra_id}`)
            setters.setIsLoading(false)
            setters.setDataEstatisticasEstoque(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    const getEstoqueObra = async (query, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        setters.setIsLoading(true)
        try {
            const response = await http.get(`/estoque?${query}`)
            console.log(response)
            setters.setIsLoading(false)
            if (response.data.data.length === 0) {
                toast.success('Limite de estoque atingido')
                return
            }
            setters.setDataEstoque(response.data.data)
            return;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                if (investidor) { setters.setSignedInvestidor(false) }
                else { localStorage.removeItem('token'); localStorage.removeItem('permisssion'); localStorage.removeItem('cliente'); localStorage.removeItem('usuario'); setters.setSigned(false) }
            }
            toast.error(err.response?.data?.msg)
            return false;
        }
    }

    //#endregion

    //#region Feito pelo agente netexperts — Painel Analítico da Obra (SOMENTE GET, read-only)

    // Trata 403 de sessão admin e relança demais erros (deixa o hook controlar loading por tab).
    const handleAnalyticsError = (err, investidor) => {
        if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') throw err
        if (err?.response?.status === 403 && !investidor) {
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
        }
        throw err
    }

    const getObraAnalyticsResumo = async (obraId, params = {}, investidor = false, signal) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await http.get(`/analytics/obra/${obraId}/resumo${query ? `?${query}` : ''}`, { signal })
            if (!response.data?.status) throw new Error(response.data?.msg || 'Erro ao carregar resumo')
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, investidor)
        }
    }

    const getObraAnalyticsArea = async (obraId, area, params = {}, investidor = false, signal) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await http.get(`/analytics/obra/${obraId}/${area}${query ? `?${query}` : ''}`, { signal })
            if (!response.data?.status) throw new Error(response.data?.msg || 'Erro ao carregar área')
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, investidor)
        }
    }

    const getObraAnalyticsDetalhes = async (obraId, area, params = {}, investidor = false, signal) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await http.get(`/analytics/obra/${obraId}/${area}/detalhes${query ? `?${query}` : ''}`, { signal })
            if (!response.data?.status) throw new Error(response.data?.msg || 'Erro ao carregar detalhes')
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, investidor)
        }
    }

    const getObraVendaContrato = async (obraId, contrato, investidor = false, signal) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        const query = new URLSearchParams({ contrato: String(contrato) }).toString()
        try {
            const response = await http.get(`/analytics/obra/${obraId}/vendas/contrato?${query}`, { signal })
            if (!response.data?.status) throw new Error(response.data?.msg || 'Erro ao carregar contrato')
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, investidor)
        }
    }

    const getObraEstoqueUnidade = async (obraId, params = {}, investidor = false, signal) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await http.get(`/analytics/obra/${obraId}/estoque/unidade?${query}`, { signal })
            if (!response.data?.status) throw new Error(response.data?.msg || 'Erro ao carregar unidade')
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, investidor)
        }
    }

    // Execuções de busca de dados (configuração agendada) de uma obra — admin only.
    const getConfiguracaoObraBusca = async (obraId, params = {}, signal) => {
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await axiosAuth.get(`/configuracao-obra-busca/${obraId}${query ? `?${query}` : ''}`, { signal })
            return response.data.data
        } catch (err) {
            return handleAnalyticsError(err, false)
        }
    }

    // Configurações de busca do sistema (agendamento por área) — admin only.
    const getConfiguracaoBusca = async (params = {}, signal) => {
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await axiosAuth.get(`/configuracao-busca${query ? `?${query}` : ''}`, { signal })
            return response.data.data
        } catch (err) {
            handleAnalyticsError(err, false)
            return []
        }
    }

    const patchConfiguracaoBusca = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/configuracao-busca/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Configuração de busca atualizada com sucesso')
            return true
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao atualizar a configuração de busca')
            return false
        }
    }

    // Datas de exibição (admin) — GET /data-exibicao
    const getDataExibicao = async (params = {}, signal) => {
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await axiosAuth.get(`/data-exibicao${query ? `?${query}` : ''}`, { signal })
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            handleAnalyticsError(err, false)
            return []
        }
    }

    const postDataExibicao = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/data-exibicao', data)
            setters.setIsLoading(false)
            toast.success(response.data.msg || 'Datas de exibição cadastradas com sucesso')
            return true
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao cadastrar as datas de exibição')
            return false
        }
    }

    const deleteDataExibicao = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.delete(`/data-exibicao/${id}`)
            setters.setIsLoading(false)
            toast.success(response.data.msg || 'Data de exibição removida com sucesso')
            return true
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao remover a data de exibição')
            return false
        }
    }

    // Datas de exibição disponíveis para o investidor (gate do painel).
    const getDatasExibicaoInvestidor = async (signal) => {
        try {
            const response = await axiosAuthInvestidor.get('/data-exibicao', { signal })
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') throw err
            return []
        }
    }

    //#endregion

    //#region Relatórios

    const fetchEmpreendimentos = async (query) => {
        try {
            const response = await axiosAuth.get(`/empreendimentos?${query}`)
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar empreendimentos')
            return []
        }
    }

    const getRelatorios = async (params = {}) => {
        const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await axiosAuth.get(`/relatorio${query ? `?${query}` : ''}`)
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao buscar relatórios')
            return []
        }
    }

    const getRelatorioObras = async (processamentoId, params = {}, { silent = false } = {}) => {
        const clean = Object.fromEntries(Object.entries({
            processamento_id: processamentoId,
            ...params,
        }).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        const query = new URLSearchParams(clean).toString()
        try {
            const response = await axiosAuth.get(`/relatorio/obras?${query}`)
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            } else if (!silent) {
                toast.error(err.response?.data?.msg || 'Erro ao buscar obras do relatório')
            }
            return []
        }
    }

    // Busca relatórios de uma obra nos processamentos recentes (limite conservador).
    const fetchRelatoriosObraByObra = async ({ codigo, nome } = {}) => {
        if (!codigo && !nome) return []

        const matched = []
        const seen = new Set()
        const perPage = 20
        const maxPages = 8

        const matchesObra = (row) => {
            if (codigo && row.codigo_obra === codigo) return true
            if (nome && row.nome_obra === nome) return true
            return false
        }

        for (let page = 0; page < maxPages; page += 1) {
            const processamentos = await getRelatorios({
                page,
                per_page: perPage,
                sort: 'data_criacao',
                sort_dir: 'desc',
            })
            if (!processamentos.length) break

            for (const processamento of processamentos) {
                const obras = await getRelatorioObras(processamento.id, { page: 0, per_page: 20 }, { silent: true })
                obras.forEach((row) => {
                    if (!matchesObra(row) || seen.has(row.id)) return
                    seen.add(row.id)
                    matched.push(row)
                })
            }

            if (processamentos.length < perPage) break
        }

        return matched.sort((a, b) => new Date(String(b.data_criacao).replace(' ', 'T')) - new Date(String(a.data_criacao).replace(' ', 'T')))
    }

    const fetchRelatoriosObraInvestidor = async (obraId) => {
        if (!obraId) return []
        try {
            const response = await axiosAuthInvestidor.get('/relatorio/obras', { params: { obra_id: obraId } })
            if (!response.data?.status) return []
            return response.data.data ?? []
        } catch (err) {
            if (err.response?.status === 403) {
                toast.error(err.response?.data?.msg || 'Acesso negado aos relatórios desta obra')
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao buscar relatórios')
            }
            return []
        }
    }

    const postRelatorio = async (data) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post('/relatorio', data)
            setters.setIsLoading(false)
            toast.success(response.data.msg || 'Relatório solicitado com sucesso')
            return true
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response?.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
            }
            toast.error(err.response?.data?.msg || 'Erro ao solicitar relatório')
            return false
        }
    }

    const downloadRelatorioObra = async (relatorioId, investidor = false) => {
        const http = investidor ? axiosAuthInvestidor : axiosAuth
        try {
            const response = await http.get('/relatorio/obras-dowload', {
                params: { relatorio_id: relatorioId },
                responseType: 'blob',
            })
            const disposition = response.headers['content-disposition']
            let fileName = 'relatorio.xlsx'
            if (disposition) {
                const match = disposition.match(/filename="?([^"]+)"?/)
                if (match?.[1]) fileName = decodeURIComponent(match[1])
            }
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            toast.success('Download iniciado')
            return true
        } catch (err) {
            if (err.response?.status === 403) {
                if (investidor) {
                    setters.setSignedInvestidor(false)
                } else {
                    localStorage.removeItem('token')
                    localStorage.removeItem('permisssion')
                    localStorage.removeItem('cliente')
                    localStorage.removeItem('usuario')
                    setters.setSigned(false)
                }
                return false
            }
            if (err.response?.data instanceof Blob) {
                try {
                    const text = await err.response.data.text()
                    const json = JSON.parse(text)
                    toast.error(json.msg || 'Erro ao baixar relatório')
                } catch {
                    toast.error('Erro ao baixar relatório')
                }
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao baixar relatório')
            }
            return false
        }
    }

    //#endregion


    return (
        <AuthContextApi.Provider
            value={{
                getObraAnalyticsResumo,
                getObraAnalyticsArea,
                getObraAnalyticsDetalhes,
                getObraVendaContrato,
                getObraEstoqueUnidade,
                getConfiguracaoObraBusca,
                getConfiguracaoBusca,
                patchConfiguracaoBusca,
                getDataExibicao,
                postDataExibicao,
                deleteDataExibicao,
                getDatasExibicaoInvestidor,
                fetchEmpreendimentos,
                getRelatorios,
                getRelatorioObras,
                fetchRelatoriosObraByObra,
                fetchRelatoriosObraInvestidor,
                postRelatorio,
                downloadRelatorioObra,
                loginInvestidor,
                checkLoginInvestidor,
                loginStep2Investidor,
                logoutInvestidor,
                getEmpreendimentosInvestidor,
                fetchEmpreendimentosInvestidorSilencioso,
                getObrasInvestidor,
                fetchObrasInvestidorSilencioso,
                getEstoqueObraDataSistema,
                getEstoqueObra,
                getVendasObraDataSistema,
                getVendasObra,
                getRecebidosObraDataSistema,
                getRecebidosObra,
                getAReceberObraDataSistema,
                getAReceberObra,
                getMovimentacaoObraDataSistema,
                getMovimentacaoObra,

                getInvestimentosDataSistema,
                getInvestimentos,
                postInvestimentos,
                patchInvestimentos,
                postInvestidores,
                patchInvestidores,
                bloquearDesbloquearInvestidores,
                getInvestidoresDataSistema,
                getInvestidores,
                getObras,
                postObras,
                patchObras,
                postObrasProcessarDados,
                getInvestidoresInvestimentos,
                postInvestimentosInvestidores,
                patchInvestimentoStatusBloquearDesbloquear,
                fetchObras,
                fetchInvestidores,
                getObraInvestidores,
                postObraInvestidor,
                deleteObraInvestidor,
                deleteUsuarios,
                profileAutenticationEmail,
                profileChangeEmailConfirmCheckLink,
                profileChangeEmailConfirm,
                profileChangeEmail,
                profileChangeSenha,
                getDashBoardataSistema,
                getLogsDataSistema,
                getLogsMetricas,
                getLogs,
                getRequestsMetricas,
                blockUnlockUsuarios,
                putRoleUsuarios,
                postUsuarios,
                getUsuariosDataSistema,
                getUsuarios,
                getUsuariosQuery,
                getRecuperacaoDeSenhaDataSistema,
                getRecuperacaoSenha,
                getRecuperacaoSenhaQuery,
                login,
                checkLogin,
                forgotPass,
                forgotChangePass,
                logout
            }}>
            {children}
        </AuthContextApi.Provider>
    )
}

export default AuthProvider;
